import { CreateContact } from '../../../domain/customerContact/createContact';
import { UpdateContact } from '../../../domain/customerContact/updateContact';
import { ContactAdapter } from '../../adapters/customer-contacts/contactsAdapters';
import { ContactDTO } from '../../http/dtos/customer-contacts/contactDTO';
import { ContactListByProjectDTO } from '../../http/dtos/customer-contacts/contactListByProjectDTO';
import { ContactListDTO } from '../../http/dtos/customer-contacts/contactListDTO';
import { CustomerContactListSelectorDTO } from '../../http/dtos/customer-contacts/customerContactListSelectorDTO';
import httpClient from '../../http/httpClient';

export const ContactRepository = {
    GetContactList: (customerId: string) => {
        return httpClient
            .get('/contacts/contacts-list' + customerId)
            .then((response: ContactListDTO[]) =>
                ContactAdapter.getContactsListAdapter(response)
            );
    },

    GetContact: (id: string) => {
        return httpClient
            .get('/contacts/contact-by-id/' + id)
            .then((response: ContactDTO) =>
                ContactAdapter.getContactAdapter(response)
            );
    },

    CreateContact: (newContact: CreateContact) => {
        return httpClient
            .post('/contacts/', newContact)
            .then((response) => response);
    },

    UpdateContact: (newContact: UpdateContact, id: number) => {
        return httpClient
            .put('/contacts/update-contact/' + id, newContact)
            .then((response) => response);
    },

    GetCustomerContactListSelector: (id: number) => {
        return httpClient
            .get('/contacts/contact-list-by-customer-id/' + id)
            .then((response: CustomerContactListSelectorDTO[]) => response);
    },

    GetCustomerContactByProjectListSelector: (id: string) => {
        return httpClient
            .get('/contacts/contact-list-by-project-id/' + id)
            .then((response: ContactListByProjectDTO[]) => response);
    },
};
